import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import styles from "../FinanceDetailV2.module.scss";

// Champ libre du bandeau KPI d'un dossier, saisi à la main et corrigeable à
// tout moment (n° de contrat financeur LS-716, compte comptable LS-717).
// `enregistrer(valeur)` porte l'appel API ; `libelleTitre` sert aux titres des
// boutons (« Saisir le … », « Corriger le … », « Enregistrer le … »).
const ChampLibreDossier = ({
  libelle,
  libelleTitre,
  valeur,
  canEdit,
  placeholder,
  enregistrer,
  messageSucces,
  messageErreur,
  onSaved,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [saisie, setSaisie] = useState(valeur || "");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setSaisie(valeur || "");
  }, [valeur]);

  // Rien à montrer tant que la saisie n'est pas ouverte et qu'aucune valeur n'existe.
  if (!valeur && !canEdit) return null;

  async function handleSave() {
    const nouvelleValeur = saisie.trim();
    if (!nouvelleValeur) return;
    setIsSaving(true);
    try {
      await enregistrer(nouvelleValeur);
      toast.success(messageSucces);
      setIsEditing(false);
      if (onSaved) onSaved(nouvelleValeur);
    } catch (error) {
      // le refus de l'API (422, 403) dit pourquoi : on le montre plutôt que le message générique
      toast.error(error?.response?.data?.message || messageErreur);
    } finally {
      setIsSaving(false);
    }
  }

  function handleCancel() {
    setIsEditing(false);
    setSaisie(valeur || "");
  }

  return (
    <div className={styles.kpiCell}>
      <div className={styles.kpiLabel}>{libelle}</div>
      {isEditing ? (
        <div>
          <input
            className={styles.periodInputEditable}
            value={saisie}
            maxLength={30}
            placeholder={placeholder}
            onChange={(e) => setSaisie(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSave();
              if (e.key === "Escape") handleCancel();
            }}
            disabled={isSaving}
            autoFocus
          />
          <button
            type="button"
            className={styles.echeancierSaveBtn}
            onClick={handleSave}
            disabled={isSaving || !saisie.trim()}
            title={`Enregistrer le ${libelleTitre}`}
          >
            <i className={`fa fa-${isSaving ? "spinner fa-spin" : "check"}`} />
          </button>
          <button
            type="button"
            className={styles.echeancierCancelBtn}
            onClick={handleCancel}
            disabled={isSaving}
            title="Annuler"
          >
            <i className="fa fa-times" />
          </button>
        </div>
      ) : (
        <div className={valeur ? styles.kpiValue : styles.kpiValueMuted}>
          {valeur || "—"}
          {canEdit && (
            <button
              type="button"
              className={styles.echeancierCancelBtn}
              onClick={() => setIsEditing(true)}
              title={
                valeur
                  ? `Corriger le ${libelleTitre}`
                  : `Saisir le ${libelleTitre}`
              }
              style={{ marginLeft: 6 }}
            >
              <i className="fa fa-pencil" />
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ChampLibreDossier;
